import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  MatDialog,
  MatPaginator,
} from "@angular/material";
import { Router } from "@angular/router";
import { AppService } from "src/_services/app.service";

@Component({
  selector: "app-operator-provider-management",
  templateUrl: "./operator-provider-management.component.html",
  styleUrls: ["./operator-provider-management.component.scss"],
})
export class OperatorProviderManagementComponent implements OnInit {
  operatorsDisplayedColumns: string[] = [
    "OperatorsId",
    "OperatorsName",
    "Currency",
  ];
  operators = new MatTableDataSource();
  count: number = 0;
  searchUserName: string = "";
  selectedPartnerId: "";
  partnersList = [];
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));

  constructor(
    private appService: AppService,
    private router: Router,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.getOurOperators();
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  getOurOperators() {
    try {
      this.appService.getOurOperators().subscribe((res) => {
        if (res.status === "RS_OK") {
          // this.operators.data = res.operators;
          this.operators = new MatTableDataSource<any>(res.operators);
          this.operators.paginator = this.paginator;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  searchOperator(event) {
    const value = event.target.value;
    this.operators.filter = value.trim().toLocaleLowerCase();
  }

  goTo(link) { 
    let linkRoute =
      `/administration/operator-providers/` + link.operator_id;
    this.router.navigate([linkRoute]);
  }
}
